import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';
import { Info } from '../styles';
import { getDate } from '../../../../utils';
import { InnerLink } from '../../../Core/Link/styles';

import {
  Wrapper,
  StyledContainer,
  FeaturedImage,
  Content,
  ArticleTitle,
  Date,
  Author,
  Copy,
} from './styles';

/*
 * This is the full width featured post that sits at the top of the blog landing page
 * primary: {object} that we get from the CMS that contains all the data for the feature post
 * image: {object} the object that holds all the data for the featured image, url, alt, etc
 * titleShort: {string} shortened version of the title to be displayed in the blog card
 * publishDate: {string} the date the blog was published, in yyyy-mm-dd format. This is passed to the getDate func to return the date in the format to display to the user
 * author: {string} the name of the author that wrote the blog post
 * metaDescription: {string} the body copy that is written to specifically display in the blog card
 * url: {string} the path that the article page is created under
 */

const FeaturedPost = ({ data: { primary }, activeFilter }) => {
  if (!primary || activeFilter) return null;
  const { featuredPost, lang } = primary[0];
  return (
    featuredPost !== null && (
      <Wrapper>
        <FeaturedImage
          src={featuredPost.headingData.imageExpanded.imageFullsizeSharp}
          alt={featuredPost.headingData.imageExpanded.imageFullsize.altTag}
        />
        <StyledContainer className="auto-margin">
          <Link to={`/blog/${featuredPost.url}`} lang={lang}>
            <Content>
              <ArticleTitle>{featuredPost.titleShort}</ArticleTitle>
              <Info className="feature-card">
                <Date>{getDate(featuredPost.publishDate)}</Date>
                {featuredPost.author.map(({ name }, index) => (
                  <Author key={`${name[0].text}-${index.toString()}`}>
                    {name[0].text}
                  </Author>
                ))}
              </Info>
              <Copy className="large">
                {ReactHtmlParser(featuredPost.headingData.teaserTextHtml)}
              </Copy>
              <InnerLink> Read more </InnerLink>
            </Content>
          </Link>
        </StyledContainer>
      </Wrapper>
    )
  );
};

FeaturedPost.propTypes = {
  data: PropTypes.shape().isRequired,
  activeFilter: PropTypes.shape(),
};

FeaturedPost.defaultProps = {
  activeFilter: null,
};

export default FeaturedPost;
